<template>
  <div class="grid-wrapper">
    <div class="offset" v-for="i in 2" :key="i">
      <span></span>
    </div>
    <div class="grid-container">
      <div class="col" v-for="(col, i) in 7" :key="i">
        {{ i + 1 }}
      </div>
    </div>
  </div>
</template>

<script></script>

<style lang="scss" scoped>
h1 {
  display: block;
}

.grid-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: layer(cover) + 100;
}

.grid-container {
  display: grid;
  margin: 0 auto;
  width: var(--width);
  grid-template-columns: repeat(var(--columns), 1fr);
  gap: var(--gutter);
  height: var(--height);
}

.col {
  background-color: rgba(0, 0, 255, 0.2);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100dvg;
  padding-top: 30px;
  width: var(--col-1);
  z-index: layer(cover);
  font-size: 10px;
  font-family: monospace;
}

.offset {
  position: absolute;
  right: 0;
  width: var(--offset);
  height: 1px;
  background-color: rgb(119, 0, 255);
  top: 50dvh;

  &:nth-child(2) {
    left: 0;
  }

  span {
    font-family: monospace;
    font-size: 12px;
    top: -40px;
    left: -10px;
    position: absolute;
    margin: 0 auto;
    color: rgb(119, 0, 255);
    font-weight: bolder;
    transform: rotate(-90deg);

    @include mq(desktop) {
      left: 20px;
      top: -20px;
      transform: rotate(0);
    }
  }

  &:before {
    width: 1px;
    height: 12px;
    background-color: rgb(119, 0, 255);
    right: 0;
    top: -6px;
    content: '';
    position: absolute;
  }

  &:after {
    width: 1px;
    height: 12px;
    background-color: rgb(119, 0, 255);
    left: 0;
    top: -6px;
    content: '';
    position: absolute;
  }
}
</style>
